import { Invoice, InvoiceStatus } from '@features/invoices/types/invoice.types';

// Mock Users
export const mockUsers = [];

// Mock Invoices
export const mockInvoices: Invoice[] = [
  {
    id: '1',
    invoiceNumber: 'FE-2024-001',
    customerName: 'Tech Solutions S.A.',
    customerRuc: '1234567-1-123456',
    date: '2024-03-15T10:00:00Z',
    dueDate: '2024-04-15T10:00:00Z',
    totalAmount: 5420.50,
    status: InvoiceStatus.APPROVED,
    createdAt: '2024-03-15T10:00:00Z',
  },
  {
    id: '2',
    invoiceNumber: 'FE-2024-002',
    customerName: 'Comercial del Norte',
    customerRuc: '9876543-2-654321',
    date: '2024-03-16T11:30:00Z',
    dueDate: '2024-04-16T11:30:00Z',
    totalAmount: 12350.75,
    status: InvoiceStatus.PENDING,
    createdAt: '2024-03-16T11:30:00Z',
  },
  {
    id: '3',
    invoiceNumber: 'FE-2024-003',
    customerName: 'Distribuidora Central',
    customerRuc: '5555555-3-111111',
    date: '2024-03-17T14:00:00Z',
    dueDate: '2024-04-17T14:00:00Z',
    totalAmount: 8900.00,
    status: InvoiceStatus.APPROVED,
    createdAt: '2024-03-17T14:00:00Z',
  },
  {
    id: '4',
    invoiceNumber: 'FE-2024-004',
    customerName: 'Servicios Empresariales',
    customerRuc: '7777777-4-222222',
    date: '2024-03-18T09:15:00Z',
    dueDate: '2024-04-18T09:15:00Z',
    totalAmount: 3250.25,
    status: InvoiceStatus.DRAFT,
    createdAt: '2024-03-18T09:15:00Z',
  },
  {
    id: '5',
    invoiceNumber: 'FE-2024-005',
    customerName: 'Importadora Global',
    customerRuc: '3333333-5-333333',
    date: '2024-03-19T16:45:00Z',
    dueDate: '2024-04-19T16:45:00Z',
    totalAmount: 18750.00,
    status: InvoiceStatus.REJECTED,
    createdAt: '2024-03-19T16:45:00Z',
  },
];

// Mock Customers
export const mockCustomers = [
  {
    id: '1',
    ruc: '1234567-1-123456',
    dv: '12',
    name: 'Tech Solutions S.A.',
    email: 'contacto@techsolutions.com',
    phone: '+507 300-1234',
    address: 'Calle 50, Edificio Plaza 2000, Piso 10',
    city: 'Ciudad de Panamá',
    country: 'Panamá',
    createdAt: '2024-01-10T10:00:00Z',
  },
  {
    id: '2',
    ruc: '9876543-2-654321',
    dv: '34',
    name: 'Comercial del Norte',
    email: 'ventas@comercialnorte.com',
    phone: '+507 300-5678',
    address: 'Vía España, Centro Comercial Plaza',
    city: 'Ciudad de Panamá',
    country: 'Panamá',
    createdAt: '2024-01-15T11:00:00Z',
  },
  {
    id: '3',
    ruc: '5555555-3-111111',
    dv: '56',
    name: 'Distribuidora Central',
    email: 'info@distribuidoracentral.com',
    phone: '+507 300-9012',
    address: 'Avenida Balboa, Torre Financiera',
    city: 'Ciudad de Panamá',
    country: 'Panamá',
    createdAt: '2024-01-20T12:00:00Z',
  },
  {
    id: '4',
    ruc: '7777777-4-222222',
    dv: '78',
    name: 'Servicios Empresariales',
    email: 'contacto@serviciosempresariales.com',
    phone: '+507 300-3456',
    address: 'Costa del Este, Business Park',
    city: 'Ciudad de Panamá',
    country: 'Panamá',
    createdAt: '2024-02-01T13:00:00Z',
  },
];

// Mock Products
export const mockProducts = [
  {
    id: '1',
    code: 'PROD-001',
    name: 'Laptop Dell Inspiron 15',
    description: 'Laptop Dell Inspiron 15, Intel i5, 8GB RAM, 256GB SSD',
    unitPrice: 750.00,
    taxRate: 7,
    category: 'Hardware',
    unit: 'Unidad',
    stock: 25,
    isActive: true,
    createdAt: '2024-01-05T10:00:00Z',
    updatedAt: '2024-01-05T10:00:00Z',
  },
  {
    id: '2',
    code: 'PROD-002',
    name: 'Monitor Samsung 24"',
    description: 'Monitor Samsung 24 pulgadas, Full HD, HDMI',
    unitPrice: 180.00,
    taxRate: 7,
    category: 'Hardware',
    unit: 'Unidad',
    stock: 40,
    isActive: true,
    createdAt: '2024-01-05T10:00:00Z',
    updatedAt: '2024-01-05T10:00:00Z',
  },
  {
    id: '3',
    code: 'SERV-001',
    name: 'Servicio de Consultoría',
    description: 'Consultoría empresarial por hora',
    unitPrice: 85.00,
    taxRate: 7,
    category: 'Consultoría',
    unit: 'Hora',
    stock: 0,
    isActive: true,
    createdAt: '2024-01-05T10:00:00Z',
    updatedAt: '2024-01-05T10:00:00Z',
  },
  {
    id: '4',
    code: 'PROD-003',
    name: 'Impresora HP LaserJet',
    description: 'Impresora HP LaserJet Pro, WiFi, Duplex',
    unitPrice: 320.00,
    taxRate: 7,
    category: 'Hardware',
    unit: 'Unidad',
    stock: 15,
    isActive: true,
    createdAt: '2024-01-05T10:00:00Z',
    updatedAt: '2024-01-05T10:00:00Z',
  },
  {
    id: '5',
    code: 'PROD-004',
    name: 'Teclado Mecánico',
    description: 'Teclado mecánico RGB, switches blue',
    unitPrice: 95.00,
    taxRate: 7,
    category: 'Hardware',
    unit: 'Unidad',
    stock: 60,
    isActive: true,
    createdAt: '2024-01-05T10:00:00Z',
    updatedAt: '2024-01-05T10:00:00Z',
  },
  {
    id: '6',
    code: 'SOFT-001',
    name: 'Licencia Microsoft Office',
    description: 'Licencia anual Microsoft Office 365 Business Standard',
    unitPrice: 120.00,
    taxRate: 7,
    category: 'Software',
    unit: 'Unidad',
    stock: 100,
    isActive: true,
    createdAt: '2024-01-10T10:00:00Z',
    updatedAt: '2024-01-10T10:00:00Z',
  },
];

// Mock Company Settings
export const mockCompany = {
  id: '1',
  ruc: '0000000-0-000000',
  dv: '00',
  name: 'Empresa Demo S.A.',
  tradeName: 'Demo Corp',
  email: 'contacto@empresademo.com',
  phone: '+507 200-0000',
  address: 'Calle Principal, Edificio Corporativo',
  city: 'Ciudad de Panamá',
  country: 'Panamá',
  logo: null,
  website: 'https://empresademo.com',
  taxRegime: 'General',
  economicActivity: 'Servicios Tecnológicos',
  createdAt: '2024-01-01T00:00:00Z',
  updatedAt: '2024-01-01T00:00:00Z',
};

// Mock Branch Offices
export const mockBranchOffices = [
  {
    id: '1',
    code: 'SUC-001',
    name: 'Sucursal Principal',
    address: 'Calle Principal, Edificio Corporativo',
    city: 'Ciudad de Panamá',
    country: 'Panamá',
    phone: '+507 200-0000',
    email: 'principal@empresademo.com',
    isMain: true,
    isActive: true,
    companyId: '1',
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    code: 'SUC-002',
    name: 'Sucursal Costa del Este',
    address: 'Costa del Este, Business Park, Local 205',
    city: 'Ciudad de Panamá',
    country: 'Panamá',
    phone: '+507 200-0001',
    email: 'costadeleste@empresademo.com',
    isMain: false,
    isActive: true,
    companyId: '1',
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-01-15T00:00:00Z',
  },
  {
    id: '3',
    code: 'SUC-003',
    name: 'Sucursal David',
    address: 'Avenida Central, Plaza Comercial',
    city: 'David',
    country: 'Panamá',
    phone: '+507 200-0002',
    email: 'david@empresademo.com',
    isMain: false,
    isActive: true,
    companyId: '1',
    createdAt: '2024-02-01T00:00:00Z',
    updatedAt: '2024-02-01T00:00:00Z',
  },
  {
    id: '4',
    code: 'SUC-004',
    name: 'Sucursal Chitré',
    address: 'Calle Comercial, Edificio Central',
    city: 'Chitré',
    country: 'Panamá',
    phone: '+507 200-0003',
    email: 'chitre@empresademo.com',
    isMain: false,
    isActive: false,
    companyId: '1',
    createdAt: '2024-03-01T00:00:00Z',
    updatedAt: '2024-03-01T00:00:00Z',
  },
];

// Dashboard Stats
export const mockDashboardStats = {
  totalInvoices: 248,
  monthlyRevenue: 45231.89,
  pendingInvoices: 15,
  approvedInvoices: 233,
  revenueData: [
    { month: 'Ene', revenue: 12500 },
    { month: 'Feb', revenue: 18200 },
    { month: 'Mar', revenue: 22100 },
    { month: 'Abr', revenue: 19800 },
    { month: 'May', revenue: 25400 },
    { month: 'Jun', revenue: 28900 },
  ],
  invoiceStatusData: [
    { name: 'Aprobadas', value: 233 },
    { name: 'Pendientes', value: 15 },
    { name: 'Rechazadas', value: 8 },
    { name: 'Borradores', value: 12 },
  ],
  recentActivity: [
    {
      id: '1',
      type: 'invoice_created',
      message: 'Nueva factura FE-2024-005 creada',
      timestamp: '2024-03-19T16:45:00Z',
    },
    {
      id: '2',
      type: 'invoice_approved',
      message: 'Factura FE-2024-003 aprobada por DGI',
      timestamp: '2024-03-18T14:30:00Z',
    },
    {
      id: '3',
      type: 'customer_added',
      message: 'Nuevo cliente agregado: Servicios Empresariales',
      timestamp: '2024-03-17T10:15:00Z',
    },
  ],
};
